import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { config } from 'config'
import { withRouter } from 'react-router-dom'
import { withApp, compareAnswers } from 'helpers'
import { Page, PageProgress, Animation, PageTitle, PageContent, PageFooter, Button, ButtonsGroup, Heading, Text, Message, Icon } from 'components/library'
import { Container, Row, Col } from 'react-grid-system'
import QuestionForm from './components/QuestionForm'
import { translate } from 'translations'
import { bindActionCreators } from 'redux'
import * as accountActions from 'store/actions/accountActions'
import { Endtest as EndtestData } from 'content'
import './EndtestView.css'

class EndtestView extends React.Component {
  state = {
    ...EndtestData,
    endtest: {...this.props.endtest}
  }

  componentDidMount() {
    this.setTheme()
    this.props.app.setLocation({ label: 'endtest' })

    if(this.props.endtest.completed && !this.props.endtest.passed) {
      this.setState(prevState => ({
        endtest: {
          ...prevState.endtest,
          hadSeenResults: true,
        }
      }))
    }
  }

  componentWillUnmount() {
    if(this.state.endtest.hadSeenResults) {
      this.props.accountActions.updateEndtest({
        completed: false,
        hadSeenResults: false,
        passed: false,
        score: 0,
        answers: [],
      })
      this.updateProgress(0)
    }
  }

  setTheme() {
    const nav = this.props.navigation.find(item => item.type === 'endtest')
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  get isComplete() {
    return this.state.questions.length === this.state.endtest.answers.length
  }

  pickSingle = (e, qId) => {
    const value = e.target.value
    const answer = { qId, value: [value] }

    this.setState(prevState => ({
      endtest: {
        ...prevState.endtest,
        answers: prevState.endtest.answers.find(item => item.qId === qId)
          ? prevState.endtest.answers.map(item => item.qId === qId ? {...answer}: item)
          : prevState.endtest.answers.concat(answer)
      }
    }))
  }

  pickMultiple = (e, qId) => {
    const value = e.target.value

    this.setState(prevState => {
      const answer = prevState.endtest.answers.find(item => item.qId === qId)
      const answerValue = (answer && answer.value) || []

      const newAnswer = {
        qId,
        value: answerValue.indexOf(value) === -1
          ? answerValue.concat(value)
          : answerValue.filter(val => val !== value)
      }

      return {
        endtest: {
          ...prevState.endtest,
          answers: answer
            ? prevState.endtest.answers.map(item => item.qId === qId ? {...newAnswer}: item)
            : prevState.endtest.answers.concat(newAnswer)
        }
      }
    })
  }

  pickDragDrop = e => {
    const item = e.dragData
    const target = e.dropData

    this.setState(prevState => {
      const formAnswer = prevState.endtest.answers.find(item => item.qId === target.qId)
      const formAnswerValue = (formAnswer && formAnswer.value) || []
      const pickedAnswer = { aId: item.id, location: target.id, label: item.id }

      const pickedAnswers = formAnswerValue.find(a => a.aId === pickedAnswer.aId)
          ? formAnswerValue.map(val => val.aId === pickedAnswer.aId ? {...pickedAnswer} : val)
          : formAnswerValue.concat(pickedAnswer)

      const newFormAnswer = { qId: target.qId, value: pickedAnswers }

      return {
        endtest: {
          ...prevState.endtest,
          answers: formAnswer
            ? prevState.endtest.answers.map(i => i.qId === newFormAnswer.qId ? {...newFormAnswer} : i)
            : prevState.endtest.answers.concat(newFormAnswer)
        }
      }
    })
  }

  pickDragDropComponent = e => {
    const item = e.dragData
    const target = e.dropData

    const singlePick = (list, curr) => {
      return list.reduce((acc, val) => {
        return val.location !== curr.location ? acc.concat(val) : acc
      }, [])
    }

    this.setState(prevState => {
      const formAnswer = prevState.endtest.answers.find(item => item.qId === target.qId)
      const formAnswerValue = (formAnswer && formAnswer.value) || []
      const pickedAnswer = { aId: item.id, location: target.id, label: item.label }

      const pickedAnswers = formAnswerValue.find(a => a.aId === pickedAnswer.aId)
        ? singlePick(formAnswerValue, pickedAnswer).map(val => val.aId === pickedAnswer.aId ? {...pickedAnswer} : val)
        : singlePick(formAnswerValue, pickedAnswer).concat(pickedAnswer)

      const newFormAnswer = { qId: target.qId, value: pickedAnswers }

      return {
        endtest: {
          ...prevState.endtest,
          answers: formAnswer
            ? prevState.endtest.answers.map(i => i.qId === newFormAnswer.qId ? {...newFormAnswer} : i)
            : prevState.endtest.answers.concat(newFormAnswer)
        }
      }
    })
  }

  handleSubmit = e => {
    this.state.questions.map(question => {
      const answerPick = this.state.endtest.answers.find(item => item.qId === question.id)

      if(answerPick) {
        const userAnswers = []
        const correctAnswers = []
        const status = {}

        switch(question.type) {
          case 'single':
          case 'multiple':
            userAnswers.push(...answerPick.value)
            question.answers.map(item => {
              if(item.isCorrect) {
                correctAnswers.push(item.id.toString())
              }

              return null
            })
            break

          case 'dragdrop':
          case 'component':
            answerPick.value.map(item => userAnswers.push({ aId: item.aId, location: item.location }))
            question.answers.map(item => correctAnswers.push({ aId: item.id, location: item.isCorrect }))
            break

          default:
            return null
        }

        status.total = correctAnswers.length
        status.picked = compareAnswers(question.type, correctAnswers, userAnswers)
        const currentScore = () => {
          switch(question.type) {
            case 'single':
            case 'multiple':
              return status.picked.correct - status.picked.wrong === status.total ? question.points : 0

            case 'dragdrop':
            case 'component':
              return status.picked.correct * (question.points / status.total)

            default:
              return 0
          }
        }
        status.score = currentScore()
        status.passed = status.score >= question.points

        this.setState(prevState => ({
          endtest: {
            ...prevState.endtest,
            score: prevState.endtest.score + status.score,
            answers: prevState.endtest.answers.map(item => item.qId === answerPick.qId
              ? {...item, status}
              : item)
          }
        }))
      }

      return null
    })

    this.setState(prevState => ({
      endtest: {
        ...prevState.endtest,
        completed: this.isComplete,
        passed: prevState.endtest.score >= config.scoreToPass,
      }
    }), () => {
      this.props.accountActions.updateEndtest(this.state.endtest)


      if(this.state.endtest.passed) {
        this.updateProgress(1)
        this.props.history.push(Routes.to('endtestPassed'))
      } else {
        this.updateProgress(0)
        this.props.history.push(Routes.to('endtestNotPassed'))
      }
    })
  }

  handleNext = e => {
    if(this.state.endtest.passed) {
      this.props.history.push(Routes.to('endtestPassed'))
    } else {
      this.props.history.push(Routes.to('endtestNotPassed'))
    }
  }

  updateProgress = progr => {
    const nav = this.props.navigation.find(item => item.type === 'endtest')
    const progress = this.props.progress.find(item => item.id === nav.id)

    if(progress.status !== 'done') {
      this.props.accountActions.updateProgress(nav.id, progr)
      this.props.app.willProgress(nav)
    }
  }

  render() {
    const getValue = question => {
      const answer = this.state.endtest.answers.find(item => item.qId === question.id)
      return answer && answer.value
    }

    const getType = question => {
      const types = {
        single: this.pickSingle,
        multiple: this.pickMultiple,
        dragdrop: this.pickDragDrop,
        component: this.pickDragDropComponent,
      }

      return types[question.type]
    }

    const getStatus = question => {
      const answer = this.state.endtest.answers.find(item => item.qId === question.id)
      return answer && answer.status
    }

    const isCorrect = q => this.isComplete && getStatus(q) && getStatus(q).passed
    const isWrong = q => this.isComplete && getStatus(q) && !getStatus(q).passed

    return (
      <Page>
        <Animation name="slideInDown" delay={100}>
          <PageTitle>
            <Heading h1>{this.state.intro.title}</Heading>
            <Heading em>{this.state.intro.description}</Heading>
          </PageTitle>
        </Animation>

        <Animation name="appear" delay={200}>
          <PageContent>
            {/*<div className="Endtest-page-intro-text">
              <Text html>{translate('endtest.introTextHTML')}</Text>
            </div>*/}
            {this.state.questions.map((question, idx) => (
              <div className="Quiz-question" key={idx}>
                <Container>
                  <Row nogutter>
                    <Col lg={6} className="Quiz-question-main">
                      <Text small>{translate('endtest.questionNo', { number: question.id })}</Text>
                      {question.info && <Text>{question.info}</Text>}
                      {question.titleIcon && <Icon name={question.titleIcon} />}
                      <Heading h3 html divStyle={{ marginTop: '1rem' }}>{question.title}</Heading>
                      <Text>{question.hint}</Text>
                    </Col>
                    <Col lg={6} className="Quiz-question-info">
                      {isWrong(question) && !this.state.endtest.passed &&
                        <Message title={translate('endtest.infoMessageTitle')}>
                          <Text>{question.message.wrong.info}</Text>
                        </Message>
                      }

                      {isWrong(question) && this.state.endtest.passed &&
                        <Message error title={question.message.wrong.title}>
                          <Text>{question.message.wrong.info}</Text>
                        </Message>
                      }

                      {isCorrect(question) &&
                        <Message success title={question.message.correct.title}></Message>
                      }
                    </Col>
                  </Row>
                  <Row nogutter>
                    <Col lg={12}>
                      <QuestionForm
                        {...question}
                        disabled={this.state.endtest.completed}
                        value={getValue(question)}
                        onPick={getType(question)} />
                    </Col>
                  </Row>
                </Container>
              </div>
            ))}
          </PageContent>
        </Animation>

        <Animation name="slideInDown" delay={300}>
          <PageFooter>
            <div className="Page-footer-left">
              <Button outline to={Routes.to('home')} icon="home" />
            </div>

            <div className="Page-footer-right">
              <PageProgress />
              <ButtonsGroup>
                {/*<Button square to={Routes.to('home')} label={translate('app.back')} icon="arrow-left" iconPos="left" />*/}
                {this.state.endtest.completed ? (
                  <Button primary square to={Routes.to('home')} label={translate('endtest.btnExit')} />
                ) : (
                  <Button primary square disabled={!this.isComplete} onClick={this.handleSubmit} label={translate('endtest.btnSubmit')} />
                )}
              </ButtonsGroup>
            </div>
          </PageFooter>
        </Animation>
      </Page>
    )
  }
}

export default withRouter(withApp(connect(
  (state, props) => ({
    endtest: state.account.endtest,
    navigation: state.content.navigation,
    progress: state.account.progress,
  }),
  (dispatch) => ({
    accountActions: bindActionCreators(accountActions, dispatch)
  })
)(EndtestView)))



// WEBPACK FOOTER //
// ./src/components/views/endtest/EndtestView.js